import DatePicker from './DatePicker'
import FieldWrapperHOC from "../../../components/hoc/FieldWrapperHOC/index.js"
import { withI18next } from '../../../lib/withI18next'


const FieldWrapper = props => {
  const errorText = (props.meta.error && props.meta.touched) ?
  props.t(`${props.meta.error}`) : props.meta.error || ''
  return (
    <DatePicker
      {...props}
      handleChange={props.input.onChange}
      onBlur={props.input.onChange}
      selected={props.input.value}
      name={props.input.name}
      error={errorText}
      required={props.required}
      touched={props.meta.touched}
    />
  )
}

export default  withI18next(['common'])(FieldWrapperHOC(FieldWrapper))



// WEBPACK FOOTER //
// ./components/uiLib/DatePicker/FieldWrapper.js